import requestService from '../requestService';
import store from '@/store';
//import router from '../../router'

export default {
    async getListQueue(uid) {
        if (store.getters.loggedUser) {
            try {
                const response = await requestService.get(`/business/${uid}/queues` ,{
                    headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
                })
                return response?.data
            }
            catch {
                // store.commit("clearUserLogged");
                // router.push('/login')
            }
        }
    },
    async getStatistic(uid) {
        if (store.getters.loggedUser) {
            try {
                const response = await requestService.get(`/business/${uid}/queueStatistic` ,{
                    headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
                })
                return response?.data
            }
            catch {
                // store.commit("clearUserLogged");
                // router.push('/login')
            }
        }
    },
    async acceptQueue(buid, puid){
        if (store.getters.loggedUser) {
            try {
                const response = await requestService.post(`/business/${buid}/queue/${puid}/accept`, "",{
                    headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
                })
                return response?.data
            }
            catch {
                // store.commit("clearUserLogged");
                // router.push('/login')
            }
        }
    },
    async acceptAllQueue(buid){
        if (store.getters.loggedUser) {
            try {
                const response = await requestService.post(`business/${buid}/queue/accept_all`, "",{
                    headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
                })
                return response?.data
            }
            catch {
                // store.commit("clearUserLogged");
                // router.push('/login')
            }
        }
    },
    async declineQueue(buid, puid){
        if (store.getters.loggedUser) {
            try {
                const response = await requestService.post(`/business/${buid}/queue/${puid}/decline`, "" ,{
                    headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
                })
                return response?.data
            }
            catch {
                // store.commit("clearUserLogged");
                // router.push('/login')
            }
        }
    },
    async getAllQueue(uid) {
        if (store.getters.loggedUser) {
            try {
                const response = await requestService.get(`/business/${uid}/queues/history` ,{
                    headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
                })
                return response?.data
            }
            catch {
                // store.commit("clearUserLogged");
                // router.push('/login')
            }
        }
    },
};